import { configureStore } from '@reduxjs/toolkit';
import { useDispatch, useSelector } from 'react-redux';

// Create the store
export const store = configureStore({
  reducer: {
    // Add your reducers here
    // For example:
    // user: userReducer,
    // theme: themeReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

// Export hooks
export const useAppDispatch = () => useDispatch();
export const useAppSelector = useSelector;